/**
 * 区域配置入口
 * 根据区域标识获取对应的配置
 */
import cnConfig from './cn.js'
import globalConfig from './global.js'

const REGION_CONFIGS = {
  cn: cnConfig,
  global: globalConfig
}

/**
 * 获取指定区域的配置
 * @param {string} region - 区域标识 'cn' | 'global'
 * @returns {object} 区域配置对象
 */
export function getRegionConfig(region) {
  return REGION_CONFIGS[region] || cnConfig
}

/**
 * 获取所有可用区域列表
 * @returns {Array} 区域信息数组
 */
export function getAvailableRegions() {
  return [
    { code: 'cn', name: '国内版', path: '/cn/home' },
    { code: 'global', name: 'Global', path: '/global/home' }
  ]
}

export { cnConfig, globalConfig }
